import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
    RouterPartialState,
    RouterState,
    ROUTER_FEATURE_KEY
} from './router.reducer';

export const currentRouterState = createFeatureSelector<
    RouterPartialState,
    RouterState
>(ROUTER_FEATURE_KEY);

export const isEditOrRelistPage = createSelector(
    currentRouterState,
    (routerState) => !!routerState.data.editing || !!routerState.data.relisting
);

export const listingId = createSelector(
    currentRouterState,
    (routerState) => routerState.params['listingId']
);

export const isEditPage = createSelector(
    currentRouterState,
    (routerState) => !!routerState.data.editing
);

export const routerData = createSelector(
    currentRouterState,
    (routerState) => routerState.data
);

export const currentCategoryId = createSelector(
    currentRouterState,
    (routerState) => routerState.data.categoryId
);

export const currentSubCategory = createSelector(
    currentRouterState,
    (routerState) => routerState.data.subCategory
);

export const params = createSelector(
    currentRouterState,
    (routerState) => routerState.params
);
